// extracted by mini-css-extract-plugin
export var avatarContainer = "_5a-0";
export var avatarTypingWave = "_5a-i";
export var gray = "_5a-f";
export var green = "_5a-c";
export var icon = "_5a-9";
export var image = "_5a-1";
export var lg = "_5a-6";
export var md = "_5a-5";
export var presenceDot = "_5a-b";
export var red = "_5a-d";
export var sm = "_5a-4";
export var status = "_5a-a";
export var typingDot = "_5a-h";
export var typingPill = "_5a-g";
export var xl = "_5a-7";
export var xs = "_5a-3";
export var xxl = "_5a-8";
export var xxs = "_5a-2";
export var yellow = "_5a-e";